import { StageColor } from '@/common/config/contact';
import type { StatusTagStatus } from './types';

export interface StatusTagConfig {
  text: string;
  backgroundColor: string;
  textColor: string;
  dotColor: string;
}

export const STATUS_TAG_CONFIG: Record<StatusTagStatus, StatusTagConfig> = {
  running: {
    text: 'Running',
    backgroundColor: '#DEF6EC', // 浅绿色背景（根据 Figma）
    textColor: '#065F46', // 深绿色文字（根据 Figma）
    dotColor: '#10B981', // 绿色圆点（根据 Figma）
  },
  completed: {
    text: 'Completed',
    backgroundColor: '#E5E5E5', // var(--200-line-, #E5E5E5) Figma 2716-71485
    textColor: StageColor.doneText, // #262626
    dotColor: StageColor.done, // #737373
  },
  pending: {
    text: 'Pending',
    backgroundColor: '#FEF3C7',
    textColor: StageColor.pendingText, // #B45309
    dotColor: StageColor.pending, // #F59E0B
  },
  failed: {
    text: 'Failed',
    backgroundColor: 'rgba(239, 68, 68, 0.10)',
    textColor: StageColor.dangerText, // #991B1B
    dotColor: StageColor.danger, // #EF4444
  },
  paused: {
    text: 'Paused',
    backgroundColor: 'rgba(245, 158, 11, 0.10)', // 橙黄色背景
    textColor: '#B45309', // 深橙色文字
    dotColor: '#F59E0B', // 橙黄色圆点
  },
  primary: {
    text: 'Primary',
    backgroundColor: '#EFF6FF', // 深绿色背景
    textColor: '#1E40AF', // 白色文字
    dotColor: '#1E40AF', // 深绿色圆点
  },
};

export type InquiryTaskStatusTagStatus = 'running' | 'completed' | 'paused';
export const INQUIRY_TASK_STATUS_TAG_CONFIG: Record<InquiryTaskStatusTagStatus, StatusTagConfig> = {
  running: {
    text: 'Running',
    backgroundColor: '#FEF3C7',
    textColor: '#92400E', // #991B1B
    dotColor: '#92400E', // #92400E
  },
  completed: {
    text: 'Completed',
    backgroundColor: '#D1FAE5', // var(--200-line-, #E5E5E5) Figma 2716-71485
    textColor: '#065F46', // #262626
    dotColor: '#065F46', // #737373
  },
  paused: {
    text: 'Paused',
    backgroundColor: '#FFE2E2', // var(--200-line-, #E5E5E5) Figma 2716-71485
    textColor: '#991B1B', // #262626
    dotColor: '#991B1B', // #737373
  },
};
